<template>
  <div id="pricing-ts">
    <div class="container">
      <div class="header py-5 w-100 text-center">
        <div class="row justify-content-center">
          <div class="mr-md-5 mr-0">
            <div class="custom-card">
              <div class="plan-name font-avenir">Unlimited users</div>
              <div class="plan-price">
                <div class="rm">RM</div>
                <div class="user font-avenir">per user</div>
                <span class="font-avenir">0</span>/ month
              </div>
              <div class="plan-features">
                <div class="magenta font-avenir">What's Included</div>

                <div
                    class="lists"
                    v-for="data in includeLists"
                    :key="data.title"
                >
                  <div class="title font-avenir">{{ data.title }}</div>
                  <ul>
                    <li
                        v-for="list in data.lists"
                        :key="list"
                        class="d-flex align-items-center"
                    >
                      <i class="fas fa-check"></i>
                      {{ list }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="cta">
                <a :href="accountCreationLink">Create Account</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      includeLists: [
        {
          title: 'On-boarding features',
          lists: ['Employee Management', 'On-boarding New Staff'],
        },
      ],
    };
  },

  computed: {
    accountCreationLink () {
      return route('auth-broker.registration', { email: '', success_redirect_url: route('tribesuite.onboarding') });
    },
  },
};
</script>

<style lang="scss" scoped>
#pricing-ts {
  .white {
    color: white !important;
  }

  .custom-card {
    width: 312px;
    height: 100% !important;
    position: relative;
    padding: 28px 26px 21px;

    &.premium {
      .plan-price-premium {
        span {
          font-size: 64px;
        }
      }
    }

    .plan-name {
      font-size: 22px;
      margin-bottom: 16px;
    }

    .plan-price,
    .plan-price-premium {
      position: relative;
      margin-bottom: 16px;

      span {
        margin-left: 32px;
      }

      .rm {
        position: absolute;
        top: 0;
        font-size: 20px;
        letter-spacing: 0;
        line-height: 27px;
      }

      .user {
        position: absolute;
        bottom: 0;
        color: #222227;
        font-size: 18px;
        font-weight: 300;
        letter-spacing: 0;
        line-height: 28px;
      }
    }

    .plan-features {
      div {
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 36px;
      }

      .magenta {
        color: #ff375e;
      }

      .lists {
        .title {
          font-size: 22px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 36px;
          margin-bottom: 10px;
        }

        ul {
          padding-left: 0;

          li {
            margin-bottom: 8px;

            .fas {
              flex-shrink: 0;
              margin-right: 14px;
              background: red;
              color: white;
              height: 20px;
              width: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              font-size: 10px;
            }

            // list-style-image: url("~/images/check.svg");
            color: #606060;

            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 24px;
          }
        }
      }
    }

    .cta {
      margin-top: 80px;

      a {
        font-family: "Open Sans", sans-serif;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 26px 21px;
        width: auto;
      }
    }
  }
}
</style>
